import React from 'react'
import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { last } from 'lodash'
import { Hidden } from '@material-ui/core'
import Cards from 'components/TemplateForm/Cards'
import Templates from 'components/Templates'
import Themes from 'components/TemplateForm/ThemesList'
// import Form from './Form'
// import { receiveTemplate, selectEmailCard } from 'actions/template'
// import { stepperIncrease } from 'actions/view'

const Email = ({
  emailCardSelected,
  // receiveTemplate,
  // selectEmailCard,
  // stepperIncrease,
}) => {
  const emailForm = (cols) => {
    switch (emailCardSelected) {
      case 'blank':
        return null
      case 'templates':
        return (
          <Templates
            // handleTemplateClick={(template) => {
            //   receiveTemplate(template)
            //   selectEmailCard('blank')
            //   stepperIncrease('task')
            // }}
            cols={cols}
            taskForm
          />
        )
      case 'themes':
        return <Themes taskForm cols={cols} />
      default:
        return (
          <div style={{ marginTop: '-60px' }}>
            <Cards cols={3} taskForm />
          </div>
        )
    }
  }

  return (
    <div>
      <Hidden only={['xs', 'sm', 'md']}>{emailForm(5)}</Hidden>
      <Hidden only={['xs', 'sm', 'lg', 'xl']}>{emailForm(4)}</Hidden>
      <Hidden only={['md', 'lg', 'xl']}>{emailForm(2)}</Hidden>
    </div>
  )
}

export default connect(
  (state) => ({
    emailCardSelected: last(state.email.cardSelected),
  }),
  null,
  // (dispatch) =>
  //   bindActionCreators(
  //     { receiveTemplate, selectEmailCard, stepperIncrease },
  //     dispatch,
  //   ),
)(Email)
